module.exports = __webpack_public_path__ + "media/images/products/cards/as_melhores_ações-e64b78914f316933c591b289b5e2fcec.png";